'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
require('styled-components');
var _babelHelpers = require('../_babelHelpers-48e7a7f7.js');
require('../settings-9ee2f03f.js');
var camelCase = _interopDefault(require('lodash/camelCase'));
require('../style-222d2b0f.js');
var b14 = require('../typography/b14.js');
require('../polished.es-a11ee845.js');
var omit = _interopDefault(require('lodash/omit'));
var style = require('../style-17209f53.js');
var b18 = require('../typography/b18.js');
var b16 = require('../typography/b16.js');

var RadioButton = function (_React$Component) {
  _babelHelpers.inherits(RadioButton, _React$Component);

  function RadioButton() {
    _babelHelpers.classCallCheck(this, RadioButton);
    return _babelHelpers.possibleConstructorReturn(this, (RadioButton.__proto__ || Object.getPrototypeOf(RadioButton)).apply(this, arguments));
  }

  _babelHelpers.createClass(RadioButton, [{
    key: "renderLabelComponent",
    value: function renderLabelComponent(large, small, label) {
      if (large) return React__default.createElement(
        b18.default,
        null,
        label
      );
      if (small) return React__default.createElement(
        b14.default,
        null,
        label
      );
      return React__default.createElement(
        b16.default,
        null,
        label
      );
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          choice = _props.choice,
          error = _props.error,
          inline = _props.inline,
          margin = _props.margin,
          iconMargin = _props.iconMargin,
          id = _props.id;
      var label = choice.label,
          large = choice.large,
          small = choice.small,
          disabled = choice.disabled;


      return React__default.createElement(
        style.RadioLabel,
        {
          disabled: disabled,
          inline: inline,
          margin: margin,
          id: camelCase(id + "_label") },
        React__default.createElement(style.RadioInput, _babelHelpers._extends({
          type: "radio",
          id: camelCase(id + "_radio"),
          disabled: disabled
        }, omit(choice, ["id"]), omit(this.props, ["id"]))),
        React__default.createElement(
          style.RadioIcon,
          { className: "radioIcon", iconMargin: iconMargin },
          React__default.createElement(style.HoveredBg, { className: "hoverBg" }),
          React__default.createElement(style.RadioCircle, { className: "radioCircle", error: error })
        ),
        this.renderLabelComponent(large, small, label)
      );
    }
  }]);
  return RadioButton;
}(React__default.Component);

RadioButton.propTypes = {
  /** contains data { id, value, label, disabled, large } */
  choice: PropTypes.shape({
    id: PropTypes.string.isRequired,
    value: PropTypes.string,
    label: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    disabled: PropTypes.bool,
    large: PropTypes.bool
  }),
  /** triggers when selected on the radio button */
  onChange: PropTypes.func,
  /** render radio button in error state if this prop is passed */
  error: PropTypes.oneOfType([PropTypes.object, PropTypes.string])
};
RadioButton.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "renderLabelComponent",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "large",
      "type": null
    }, {
      "name": "small",
      "type": null
    }, {
      "name": "label",
      "type": null
    }],
    "returns": null
  }],
  "displayName": "RadioButton",
  "props": {
    "choice": {
      "type": {
        "name": "shape",
        "value": {
          "id": {
            "name": "string",
            "required": true
          },
          "value": {
            "name": "string",
            "required": false
          },
          "label": {
            "name": "union",
            "value": [{
              "name": "object"
            }, {
              "name": "string"
            }],
            "required": false
          },
          "disabled": {
            "name": "bool",
            "required": false
          },
          "large": {
            "name": "bool",
            "required": false
          }
        }
      },
      "required": false,
      "description": "contains data { id, value, label, disabled, large }"
    },
    "onChange": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "triggers when selected on the radio button"
    },
    "error": {
      "type": {
        "name": "union",
        "value": [{
          "name": "object"
        }, {
          "name": "string"
        }]
      },
      "required": false,
      "description": "render radio button in error state if this prop is passed"
    }
  }
};

module.exports = RadioButton;
//# sourceMappingURL=radio-button.js.map
